// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"MessageBox-module-checkboxWrapper","cannedMessageInput":"MessageBox-module-cannedMessageInput","schedulerContainer":"MessageBox-module-schedulerContainer"};